import { useWallet } from "@/hooks/useWallet";

/* ── Isolated Wallet Balance Card ─────────────────
   Owns its own Supabase connection via useWallet.
   Renders instantly from SWR cache; never blocks parent.
───────────────────────────────────────────────── */
export default function WalletBalanceCard() {
  const { wallet, loading } = useWallet();
  const balance = wallet?.balance ?? 0;

  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-5 text-center">
      <div className="w-10 h-10 rounded-lg bg-rose-50 text-rose-600 flex items-center justify-center mx-auto mb-2">
        <i className="ri-wallet-3-line text-lg" />
      </div>
      {loading && !wallet ? (
        <div className="h-6 bg-stone-200 rounded animate-pulse mx-auto w-24 mb-2" />
      ) : (
        <p className="font-display text-lg font-bold text-stone-800">
          NT$ {balance.toLocaleString()}
        </p>
      )}
      <p className="font-body text-[11px] text-stone-400 mt-0.5">可用餘額</p>
    </div>
  );
}